const Container = ({
	direction,
	children,
	modifier,
	store,
	mobileWrapper = false,
	large = false,
}) => {
	const mainClass = "syndicated-container";
	let classes = mainClass;

	if (direction) classes += ` ${mainClass}--flex-${direction}`;

	if (modifier) classes += ` ${mainClass}--${modifier}`;

	if (large) classes += ` ${mainClass}--large`;

	if (store) classes += ` ${mainClass}--${store}`;

	if (mobileWrapper) classes += ` ${mainClass}--with-mobile-wrapper`;

	return <div className={classes}>{children}</div>;
};

export default Container;
